import "./formWarning.component.scss";

interface IComponentBindings {
    title?: string;
}

export class FormWarningComponentController implements angular.IComponentController, IComponentBindings {

    title: string;

    static $inject = [];

    constructor() {}

    $onInit() { }

}

export class FormWarningComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    transclude: boolean;

    constructor() {
        this.bindings = {
            title: "@"
        };

        this.transclude = true;

        this.controller = FormWarningComponentController;
        this.template = require("./formWarning.component.html");
    }
}
